import React from 'react';
import { Badge, Button, Row, Card, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { getTraducaoTrocaPor as trad, getCampoTraducao as tradCampo } from '../../../../../../utils/getTraducoes';

function CompProduct(props) {
  const disp = props.product.numerovagas - props.product.orderCount;
  const promotionalCode = props.cart.promotionalCode ? props.cart.promotionalCode : {};

  var cartProduct = () => {
    return props.cart.products.find((item) => {
      return item.idsubitems === props.product.idsubitems;
    });
  }
  return (
    <Row className="my-1">
      <Col className="px-3">
        <Card className="w-100">
          <Card.Body className="px-3 py-1">
            {props.product[tradCampo(props.language)] + " - " + props.product.idsubitems}
          </Card.Body>

          <Card.Footer className="valorProduto p-0 pl-3 d-flex justify-content-between text-success align-items-center">
            <div>
              {props.product.productValueDiscount > 0 ?
                <>
                  <s className="text-secondary pr-2">
                    {props.product.productValue ?
                      (+(props.product.productValue)).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) : "Sem valor"
                    }
                  </s>
                  {props.product.productValueDiscount ?
                    (+(props.product.productValueDiscount)).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) : "Sem valor"
                  }
                </>
                :
                <>
                  {
                    props.product.productValue ?
                      (+(props.product.productValue)).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) : "Sem valor"
                  }
                </>
              }

              {(() => {
                if (props.product.mostravagas === "N") {// mudar para "S" quando estiver implementado
                  let showDisp = disp;
                  if ((Object.keys(promotionalCode)).length !== 0) {
                    showDisp = promotionalCode.qtdmax - promotionalCode.pedidos_count;
                    return <Badge variant="secondary" className="ml-1">({(() => {
                      return `${showDisp} ${showDisp > 1 ? `disponíveis` : `disponível`}`;
                    })()})</Badge >;
                  }
                  if(props.product.numerovagas > 0){
                    return <Badge variant="secondary" className="ml-1">({(() => {
                      return `${showDisp} ${showDisp > 1 ? `disponíveis` : `disponível`}`;
                    })()})</Badge >;
                  }
                }
              })()}              
            </div>
            <div className="qtInsc d-flex justify-content-between align-items-center">
              {(() => {
                if ((Object.keys(promotionalCode)).length !== 0){
                  if (promotionalCode.qtdmax > 0) {
                    const promCodeDisp = promotionalCode.qtdmax - promotionalCode.pedidos_count;
                    if (promCodeDisp < props.product.qtdemin) {
                      return false;
                    }
                  }
                }
                if (props.product.numerovagas === 0) {
                  return true;
                } else {
                  if (props.product.qtdemin <= disp) {
                    if (disp > 0) {
                        return true;
                    }
                  }
                }
                return false;
              })() ?
                <>
                  <Button style={{width:"1.5rem"}} className="p-0" disabled={!cartProduct()} onClick={() => props.removeProductCart(props.product.idsubitems)}>-</Button>
                  <div className="qtInscCont px-2">
                    {cartProduct() ? cartProduct().qt : 0}
                  </div>

                  <Button style={{width:"1.5rem"}} className="p-0" disabled={(() => {
                    if ((Object.keys(promotionalCode)).length !== 0) {
                      if (promotionalCode.qtdmax > 0) {
                        const promCodeDisp = promotionalCode.qtdmax - promotionalCode.pedidos_count;
                        if (promCodeDisp < props.product.qtdemin) {
                          return true;
                        }
                        if (cartProduct()) {
                          if (cartProduct().qt >= promCodeDisp) {
                            return true;
                          }
                        }
                      }
                    }
                    if (props.product.numerovagas > 0) {
                      if (cartProduct()) {
                        if (cartProduct().qt >= disp) {
                          return true;
                        }
                      }
                    }
                    if (props.product.qtdemax > 0) {
                      if (cartProduct()) {
                        if (cartProduct().qt >= props.product.qtdemax) {
                          return true;
                        }
                      }
                    }
                    return false;
                  })()} onClick={() => props.addProductCart(props.product.idsubitems)}>+</Button>
                </>
                :
                <Badge variant="danger">Esgotado</Badge >
              }
            </div>
          </Card.Footer>
        </Card>
      </Col>
    </Row>
  );
}

const mapStateToProps = (state) => {
  return {
    trads: state.reducerTraducoes, 
    evento: state.reducerEventos[0] ? state.reducerEventos[0] : state.reducerEventos,
    produtos: state.reducerPesquisaSubitem
  };
}
export default connect(mapStateToProps)(CompProduct);
